/*** [通过参数名获取url中的参数值]* 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明* @param  {[string]} queryName [参数名]* @return {[string]}           [参数值]*/
export const getQueryValue = (queryName) => {
  const url = window.location.href
  let urlStr = url.split('?')[1]
  const urlSearchParams = new URLSearchParams(urlStr)
  const result = Object.fromEntries(urlSearchParams.entries())
  return result && result[queryName]
}
